import { isMandatory, isInRange, isUnique } from 'utils/simple-validations';

export const getCommissionsValidationRules = collection => {
  return {
    commissionId: [
      isUnique(
        x => x?.document?.commissionId,
        document => collection.filter(x => x.document.documentCommissionId !== document.documentCommissionId)
      ),
      isMandatory()
    ],
    commissionPercent: [isInRange(0, 100)]
  };
};
